import {GLOBAL} from "./globals";

export function newUUID(): string {
    return GLOBAL.window().crypto.randomUUID();
}